
    import './styles.scoped.css';
    export default {
  "trigger": "awsui_trigger_lpshu_1mdhp_141",
  "custom": "awsui_custom_lpshu_1mdhp_147",
  "default": "awsui_default_lpshu_1mdhp_156",
  "selected": "awsui_selected_lpshu_1mdhp_172",
  "trigger-wrapper": "awsui_trigger-wrapper_lpshu_1mdhp_183",
  "dot": "awsui_dot_lpshu_1mdhp_208"
};
  